export const redirectToCharlie = () =>
  window.location.replace('https://www.charliehr.com')
